// formatMoney — DRY: KES money formatting shared by the dashboard's stat
// cards (abbreviated) and row-level amounts (full, comma-separated).

// "KES 15,000" — the one formatter lives in shared (the API builds the same text for its error messages).
export { formatKes } from "@dm-lms/shared/utils";

// "247K" once over 1000, otherwise the plain comma-separated number.
export function formatKesAbbreviated(amountKes: number): string {
  if (amountKes > 1000) return `${Math.round(amountKes / 1000)}K`;
  return amountKes.toLocaleString();
}
